module.exports = __webpack_public_path__ + "img/bgfw5.7afdd7ab.png";